import * as React from "react";
import {Component, Fragment} from "react";
import {connect} from "react-redux";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {IRootState} from "../../store";
import {CommandBarButton, MessageBarType, PrimaryButton, TextField} from "office-ui-fabric-react";
import Actions from "../../redux/Actions";
import {openFileDownload} from "../../utils/Utils";
import { DurableFunctionInstance } from "../../models/DurableFunctionInstance";
import MailroomDurableFunctionInstanceList from "./MailroomDurableFunctionInstanceList";
import {Link} from "react-router-dom";

interface MailroomReportDownloadCardProps {
    apiService: ApiService;
}

interface MailroomReportDownloadCardState {
    instanceIdToDownload: string;
    instance?: DurableFunctionInstance;
}

class MailroomReportDownloadCard extends Component<MailroomReportDownloadCardProps & DispatchProps,MailroomReportDownloadCardState> {


    constructor(props: MailroomReportDownloadCardProps & DispatchProps) {
        super(props);

        this.state = {
            instanceIdToDownload: ""
        };
    }

    async componentDidMount(): Promise<void> {
    }

    async componentDidUpdate(prevProps: Readonly<MailroomReportDownloadCardProps & DispatchProps>, prevState: any): Promise<void>
    {
    }

    private triggerReportGeneration = async () => {
        const instance = await this.props.apiService.triggerMailroomReportOrchestration();

        await this.props.dispatch(Actions.showMessageBar(`Started mailroom report instance with id ${instance.durableFunctionInstanceId}`, MessageBarType.success));

        this.setState({instanceIdToDownload: instance.durableFunctionInstanceId, instance});
    }

    private triggerDownload = async () => {

        console.log(`downloading ${this.state.instanceIdToDownload}`);

        const response = await this.props.apiService.downloadMailroomReport(this.state.instanceIdToDownload);
        await openFileDownload(response)
    }

    private onRefreshClick = async () => {
        const instance = await this.props.apiService.getMailroomFunctionInstance(this.state.instanceIdToDownload);

        this.setState({ instanceIdToDownload: instance.durableFunctionInstanceId, instance });
    }

    private buildDurableFunctionBox() {

        if (this.state.instance == null) {
            return <div></div>
        }

        return <MailroomDurableFunctionInstanceList
            title={"Mailroom Report Function"}
            enableRowLinks={false}
            instances={[this.state.instance]}
            columns={MailroomDurableFunctionInstanceList.genericColumns}>
            <CommandBarButton text="Refresh" iconProps={{ iconName: "refresh" }} onClick={this.onRefreshClick} />
        </MailroomDurableFunctionInstanceList>

    }

    public render(): JSX.Element {
        return (
            <Fragment>
                {this.state.instance == undefined ? null : this.buildDurableFunctionBox()}
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Generate/Download Mailroom Report</span>
                    </div>
                    <div className="card__content">
                        <div className="flex-row flex--justify-content-center">
                            <TextField
                                label="Report ID To Download"
                                value={this.state.instanceIdToDownload}
                                onChange={(e: any) => {
                                    this.setState({
                                        instanceIdToDownload: e.target.value
                                    })
                                }}
                                style={{ width: '30rem'}}
                            />
                        </div>
                        <br/>
                        <div className="flex-row flex--justify-content-center">
                            <PrimaryButton text="Generate Report" onClick={this.triggerReportGeneration} style={{marginRight: '1rem'}} />

                            <Link to={`/cdb-admin/mailroom/reports/${this.state.instanceIdToDownload}`} target="_blank">
                                <PrimaryButton text="Open Report (in browser)" style={{ marginLeft: '1rem' }} />
                            </Link>
                            <PrimaryButton text="Download Report (csv)" onClick={this.triggerDownload} style={{ marginLeft: '1rem' }} />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): MailroomReportDownloadCardProps => {
        return {
            apiService: state.auth.apiService
        };

    }
)(MailroomReportDownloadCard)